/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Status, Notification, Organization, Role } from "./index";
import {BusinessType} from './enums/business.type';
import {OrganizationType} from './Enums';

export class User {
  ID: string;
  COMPANY: string;
  NAME_FIRST: string;
  NAME_LAST: string;
  EMAIL: string;
  ADDRESS: string;
  ADDRESS_EXT: string;
  CITY: string;
  STATE: string;
  STATUS: Status;

  BUSINESS_TYPE: BusinessType;

  ZIP: string;
  TELEPHONE: string;
  LAST_ACTIVITY: string;
  RESET_CODE_EXPIRY: string;
  SAVE_REPORTS: boolean;
  SIGN_UP_DATE: string;
  INVITE_DATE: string;
  REQUEST_DATE: string;
  SUB_TYPE: string;
  SUB_EXP: string;
  SILENCED: boolean;
  CREDITS: number;
  EXPRESS: number;
  THUMBNAIL_IMAGE: string;
  ORGANIZATION: Organization;
  NOTIFICATIONS: Array<Notification>;
  USER_ROLES: Array<Role>;
  ACCESS: string;

  FORCE_PASS_RESET: boolean;
  INVITE_CODE: string;
  PROMO_CODE: String;
  PREMIUM: boolean;
  REQUIRE_PASS_NO_REGISTER: boolean;

  static parse(json: any): User {
    if (json) {
      const u = new User();
      u.ID = json.ID;
      u.NAME_FIRST = json.NAME_FIRST;
      u.NAME_LAST = json.NAME_LAST;
      u.EMAIL = json.EMAIL;
      u.COMPANY = json.COMPANY;
      u.ADDRESS = json.ADDRESS;
      u.ADDRESS_EXT = json.ADDRESS_EXT;
      u.CITY = json.CITY;
      u.STATE = json.STATE;
      u.STATUS = Status[<string>json.STATUS];
      u.ZIP = json.ZIP;
      u.TELEPHONE = json.TELEPHONE;
      u.LAST_ACTIVITY = json.LAST_ACTIVITY;
      u.RESET_CODE_EXPIRY = json.RESET_CODE_EXPIRY;
      u.SAVE_REPORTS = json.SAVE_REPORTS;
      u.SIGN_UP_DATE = json.SIGN_UP_DATE;
      u.INVITE_DATE = json.INVITE_DATE;
      u.REQUEST_DATE = json.REQUEST_DATE;
      u.SUB_TYPE = json.SUB_TYPE;
      u.SUB_EXP = json.SUB_EXP;
      u.SILENCED = json.SILENCED;
      u.CREDITS = json.CREDITS;
      u.EXPRESS = json.EXPRESS;
      u.THUMBNAIL_IMAGE = json.THUMBNAIL_IMAGE;
      u.ACCESS = json.ACCESS;
      u.BUSINESS_TYPE = json.BUSINESS_TYPE;
      u.PREMIUM = json.PREMIUM;
      u.REQUIRE_PASS_NO_REGISTER = json.REQUIRE_PASS_NO_REGISTER;

      if (json.ORGANIZATION)
        u.ORGANIZATION = Organization.parse(json.ORGANIZATION);

      if (json.NOTIFICATIONS)
        u.NOTIFICATIONS = Notification.parseArray(json.NOTIFICATIONS)

      if (json.USER_ROLES)
        u.USER_ROLES = Role.parseArray(json.USER_ROLES);

      u.FORCE_PASS_RESET = json.FORCE_PASS_RESET;
      u.INVITE_CODE = json.INVITE_CODE;

      return u;
    } else { return null; }
  }

  static parseArray(json: any[]): User[] {
    const arr = [];

    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(User.parse(j));
        }
      }
    }

    return arr;
  }

  get isOrganization(): boolean{
    return this.ORGANIZATION ? true : false;
  }

  get getBusinessType(): string{
    switch (this.BUSINESS_TYPE) {
      case BusinessType.LENDER:
        return 'SBA Lender';
      case BusinessType.SBDC:
        return 'SBDC';
      case BusinessType.BUSINESS_OWNER:
        return 'Business Owner';
      case BusinessType.BROKER:
        return 'Broker';
      case BusinessType.ACCOUNTANT:
        return 'Accounting Firm';
      case BusinessType.OTHER:
        return 'Other';
      default:
        return '';
    }
  }
}


export class Pswd {
  OLD_PASSWORD: string;
  NEW_PASSWORD: string;

  static parse(json: any): Pswd {
    if (json) {
      const p = new Pswd();

      p.OLD_PASSWORD = json.OLD_PASSWORD;
      p.NEW_PASSWORD = json.NEW_PASSWORD;

      return p;
    } else { return null; }
  }

}
